import { useMutation } from "@tanstack/react-query";

import { authApi } from "@/features/identity/services/auth.api";
import { setAccessToken } from "@/lib/token-storage";
import { useAppDispatch } from "@/store/hooks";
import { setCredentials } from "@/store/auth/authSlice";

/** Same credential-persisting shape as useLogin.ts — verifying the OTP
 * auto-logs the user in (see the note in auth.api.ts). */
export function useVerifyOtp() {
  const dispatch = useAppDispatch();

  return useMutation({
    mutationFn: authApi.verifyOtp,
    onSuccess: (session) => {
      setAccessToken(session.accessToken);
      dispatch(setCredentials({ user: session.user }));
    },
  });
}
